<template>
    <div class="fence-list">
        <div class="option-box" v-for="(item,index) in data" :key="index" @click.stop="edit(item)">
            <div class="option-top">
                <div class="option-top-left">
                    <div class="rail-name">{{item.fenceName}}</div>
                </div>
                <img class="option-img" src="@/assets/images/delete.png" background-size="cover" @click.stop="remove(item.fenceId)"/>
            </div>
            <div class="option-bottom">{{item.addr}}</div>
        </div>

        <!-- <div class="fence" v-for="(item, index) in data" :key="index" @click.stop="edit(item)">
            <div class="title">
                <i>{{item.geozoneName}}</i>
                <i class="iconfont icondelete" @click.stop="remove(item.geozoneId)"></i>
            </div>
            <div class="info">
                <div class="radius">
                    <span>进入/离开告警</span>
                    <i>半径{{item.radius || 0}}米</i>
                </div>
                <div class="address text-ellipsis">{{item.address}}</div>
            </div>
        </div> -->
    </div>
</template>

<script>
export default {
    props: {
        data: {
            type: Array,
            default: () => {
                return [];
            }
        }
    },
    methods: {
        /**
         * 删除围栏
         * @param {Object} obj 当前围栏数据
         */
        remove(obj) {
            this.$emit('remove', obj);
        },

        /**
         * 编辑围栏
         * @param {Object} obj 当前围栏数据
         */
        edit(obj) {
            this.$emit('edit', obj);
        }
    }
};
</script>

<style lang="scss" scoped>

    .fence-list {
        padding: 16px 0;
        display: flex;
        flex-direction: column;
        align-items: center;
        
    // 危险区域列表
    .option-box{
        background: #fff;
        margin-bottom: 25px;
        width: 670px;
        height: 180px;
        padding: 0 32px 0 35px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        border-radius: 20px;
    }
    .option-top{
        display: flex;
        justify-content: space-between;
        margin-bottom: 20px;
    }
    .option-top-left{
        display: flex;
        align-items: center;
    }
    .rail-name{
    font-size: 32px;
    font-weight: 600;
    color: #111111;
    margin-right: 15px;
    }
    .rail-state{
    font-size: 20px;
    font-weight: 500;
    padding: 2px 10px;
    text-align: center;
    color: #FFFFFF;
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
    border-bottom-right-radius: 20px;
    }
    .option-img{
    width: 30px;
    height: 30px;
    }
    .option-bottom{
    font-size: 24px;
    font-weight: 400;
    color: #999;
    }
}

</style>